/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import './ApplyLoanModal.css';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import _ from 'lodash';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import moment from 'moment';
import CompDirection from '../../../themes/CompDirection';
import { DatePickerInput } from '../../../../components';
import { defaultDateFormatting } from '../../../helper';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allLoanTypes: any;
  callBackGetData: (data: any) => void;
  trans?: any;
}

const ApplyLoanModalPresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allLoanTypes,
  trans,
}: ModalProps) => {
  const [remarks, setRemarks] = useState('');
  const [amount, setAmount] = useState();
  const [loanComments, setLoanComments] = useState('');
  const [loanTypeName, setLoanTypeName] = useState('');
  const [loanTypeId, setLoanTypeId] = useState(0);

  const [durationName, setDurationName] = useState('');

  const [startDate, setStartDate] = useState<any>(new Date());

  const handleSetLoanType = (loanName: any) => {
    const getLoan = _.filter(allLoanTypes, function (loan: any) {
      return loan.name === loanName;
    });
    if (getLoan.length) {
      const loan_type = getLoan[0];
      setLoanTypeId(loan_type.id);
      setLoanComments(loan_type?.comments);
      setLoanTypeName(loanName);
    }
  };

  const handleSubmit = () => {
    callBackGetData({
      loan_type_id: loanTypeId,
      duration: durationName,
      amount: amount,
      startDate: startDate,
      comment: remarks,
    });
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="755px"
      modalWidth="450px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Apply Recurring Payment') }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          style={{
            marginTop: '15px',
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              border: '1px solid #0000001F',
              borderRadius: '15px',
              padding: '20px',
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <CustomAutoComplete
                  label={trans('Recurring Payment Type')}
                  helperText={loanComments && (trans(`Message: ${loanComments}`))}
                  options={_.map(allLoanTypes, (loan: any) => {
                    return loan.name;
                  })}
                  value={loanTypeName}
                  onChange={(event: any, newValue: any) => {
                    handleSetLoanType(newValue);
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  placeholder={trans('Duration')}
                  helperText={trans('in months')}
                  label={trans('Duration')}
                  type="number"
                  value={durationName}
                  onChange={(e: any) => {
                    if (e.target?.value > 0 && e?.target?.value <= 99) {
                      setDurationName(e.target.value);
                    } else {
                      setDurationName('');
                    }
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <DatePickerInput
                  width="100%"
                  label={trans('Issue Date')}
                  value={new Date(startDate)}
                  onChange={(newValue: Date | string) => {
                    const formattedDate = moment(newValue).format(
                      defaultDateFormatting,
                    );
                    setStartDate(formattedDate);
                  }}
                  supportUTC={false}
                />
              </Grid>

              <Grid item xs={12}>
                <CustomTextField
                  type="number"
                  label={trans('Amount')}
                  placeholder={trans('Write Amount')}
                  value={amount}
                  onChange={(e: any) => setAmount(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <CustomTextField
                  type="string"
                  label={trans('Remarks')}
                  placeholder={trans('Write Remarks')}
                  value={remarks}
                  onChange={(e: any) => setRemarks(e.target.value)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CompDirection>

      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default ApplyLoanModalPresenter;
